import DroitCust from './droit-cust';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DroitDef extends DroitCust {}
